<ngx-extended-pdf-viewer
  *ngIf="blob"
  [src]="blob"
  [height]="'80vh'"
  [showToolbar]="true"
  [showPagingButtons]="true"
  [showZoomButtons]="true"
  [showFindButton]="true"
  [textLayer]="true"
  [handTool]="false"
  [contextMenuAllowed]="true"
  [showSidebarButton]="false"
  [showOpenFileButton]="false"
  [showPrintButton]="false"
  [showDownloadButton]="false"
  [showPresentationModeButton]="false"
  [showRotateButton]="true"
  [showHandToolButton]="false"
  [showScrollingButton]="false"
  [showSpreadButton]="false"
  [showPropertiesButton]="false"
  [showSecondaryToolbarButton]="false"
  [showTextEditor]="false"
  [showStampEditor]="false"
  [showDrawEditor]="false"
  [showHighlightEditor]="false">
</ngx-extended-pdf-viewer>
